export default [{
  header: 'Configuraciones',
  icon: 'PackageIcon',
  i18n: 'Configuraciones',
  items: [
    {
      url: null,
      name: 'Mantenedores',
      slug: 'settings',
      icon: 'FileIcon',
      permiso: 'ED004',
      submenu: [
        {
          url: { name: 'maintainer-files' },
          name: 'Documentos',
          icon: 'library_books',
          i18n: 'Documents',
          permiso: 'ED005'
        },
        {
          url: { name: 'maintainer-institutions' },
          name: 'Instituciones',
          icon: 'library_books',
          permiso: 'ED006',
          i18n: 'Instituciones'
        },
        {
          url: { name: 'maintainer-subjects' },
          name: 'Destinos',
          icon: 'library_books',
          permiso: 'ED007',
          i18n: 'Destinos'
        },
        {
          url: { name: 'maintainer-services' },
          name: 'Servicios',
          icon: 'library_books',
          permiso: 'ED110',
          i18n: 'Servicios'
        },
        {
          url: { name: 'maintainer-regions' },
          name: 'Regiones',
          icon: 'library_books',
          permiso: 'ED111',
          i18n: 'Regiones'
        },
        {
          url: { name: 'maintainer-activities' },
          name: 'Actividades',
          slug: '/herramientas/mantenedor-actividades',
          icon: 'library_books',
          permiso: 'ED048',
          i18n: 'Actividades'
        },
        {
          url: { name: 'maintainer-kanban-states' },
          name: 'Estados Kanban',
          slug: '/herramientas/mantenedor-estados-kanban',
          icon: 'library_books',
          permiso: 'ED059',
          i18n: 'States'
        },
        {
          url: { name: 'settings-roles' },
          name: 'Roles',
          icon: 'library_books',
          permiso: 'ED237',
          i18n: 'States'
        },
        {
          url: { name: 'settings-options' },
          name: 'Mantenedor de opciones',
          slug: '/configuraciones/opciones',
          icon: 'library_books',
          permiso: 'FEB99',
          i18n: 'States'
        },
        {
          url: { name: 'integrations-manager' },
          name: 'Integraciones',
          icon: 'library_books',
          i18n: 'Integraciones',
          permiso: 'WB510'
        }
      ]
    },
    {
      url: null,
      name: 'Empresa',
      slug: 'settings',
      icon: 'FileIcon',
      permiso: '*', // TODO: set permission
      submenu: [
        {
          url: { name: 'access-profiles' },
          name: 'Perfiles',
          icon: 'library_books',
          i18n: 'Documents',
          permiso: 'ED124'
        },
        {
          url: { name: 'users-management' },
          name: 'Adm. usuarios',
          icon: 'library_books',
          i18n: 'Documents',
          permiso: 'ED125'
        },
        {
          url: { name: 'settings-params' },
          name: 'Mantenedor de parametros',
          slug: '/configuraciones/parametros',
          icon: 'library_books',
          permiso: 'FEB99',
          i18n: 'States'
        }
      ]
    },
    {
      url: null,
      name: 'Transacciones',
      slug: 'InboxIcon',
      icon: 'DollarSignIcon',
      permiso: 'TRS01',
      submenu: [
        {
          url: { name: 'transactionality' },
          name: 'Transaccionalidad',
          icon: 'DollarSignIcon',
          permiso: 'TRS01',
          i18n: 'Transaccionalidad'
        }
      ],
    },
  ]
}];
